module.exports = __webpack_public_path__ + "static/media/masonhayes.df33752c.png";